import { chunkReloadAttemptKey } from '@/config/storage.config'

export function isChunkLoadError(error: unknown): boolean {
  if (!error || typeof error !== 'object' || !('message' in error) || typeof error.message !== 'string') {
    return false
  }

  return /^(Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS for)/i.test(error.message)
}

export function installChunkLoadRecovery(): () => void {
  const onPreloadError = (event: Event) => {
    const error = 'payload' in event ? event.payload : undefined
    if (!isChunkLoadError(error) || !window.navigator.onLine) return

    try {
      // One automatic reload per tab session, including across builds and different chunks.
      // Do not clear this when a dependency loads: the page itself may still fail afterwards.
      if (window.sessionStorage.getItem(chunkReloadAttemptKey)) return
      window.sessionStorage.setItem(chunkReloadAttemptKey, '1')
      if (window.sessionStorage.getItem(chunkReloadAttemptKey) !== '1') return
    } catch {
      // Without a durable guard we cannot safely retry automatically.
      return
    }

    // Keep Vite's rejection intact (no preventDefault), so failed recovery reaches errorElement.
    window.location.reload()
  }

  window.addEventListener('vite:preloadError', onPreloadError)
  return () => window.removeEventListener('vite:preloadError', onPreloadError)
}
